class o extends HTMLElement{constructor(){super(),this.form=this.querySelector("form"),this.form.querySelector("[name=id]").disabled=!1,this.form.addEventListener("submit",r=>this.onSubmitHandler(r));const e=document.querySelectorAll("cart-notification");this.cartNotification=e[e.length-1],this.submitButton=this.querySelector('[type="submit"]'),this.submitButtonText=this.submitButton.querySelector("span"),this.hideErrors=this.dataset.hideErrors==="true"}onSubmitHandler(e){e.preventDefault();const r="loading";if(this.submitButton.classList.contains(r))return;this.handleErrorMessage(),this.cartNotification.setActiveElement(document.activeElement),this.submitButton.setAttribute("aria-disabled",!0),this.submitButton.classList.add(r);const s=theme.fetchConfig("javascript");s.headers["X-Requested-With"]="XMLHttpRequest",delete s.headers["Content-Type"];const i=new FormData(this.form);i.append("sections",this.cartNotification.getSectionsToRender().map(t=>t.id)),i.append("sections_url",window.location.pathname),s.body=i,fetch(`${theme.routes.cart_add_url}`,s).then(t=>t.json()).then(t=>{if(t.status){publish(PUB_SUB_EVENTS.cartError,{source:"product-form",productVariantId:i.get("id"),errors:t.errors||t.description,message:t.message}),this.handleErrorMessage(t.description);return}this.error||publish(PUB_SUB_EVENTS.cartUpdate,{source:"product-form",productVariantId:i.get("id"),cartData:t}),this.error=!1,this.cartNotification.renderContents(t)}).catch(t=>{console.error(t)}).finally(()=>{this.submitButton.classList.remove(r),this.submitButton.removeAttribute("aria-disabled")})}handleErrorMessage(e=!1){this.hideErrors||(this.errorMessageContainer=this.errorMessageContainer||this.querySelector(".product-form__error-container"),this.errorMessage=this.errorMessage||this.errorMessageContainer.querySelector(".product-form__error-message"),this.errorMessageContainer.toggleAttribute("hidden",!e),e&&(this.errorMessage.textContent=e))}}customElements.define("product-form",o);
document.addEventListener('DOMContentLoaded', function () {
  const buyNowForms = Array.from(document.querySelectorAll('form[action="/cart/add"]'));
  let buyNowForm = null;
  let buyNowButton = null;

  for (const form of buyNowForms) {
    const button = form.querySelector('button[type="submit"]');
    const span = button?.querySelector('span.button-text');
    if (span?.textContent.trim() === 'Buy Now') {
      buyNowForm = form;
      buyNowButton = button;
      break;
    }
  }

  const buttonTextEl = buyNowButton?.querySelector('.button-text');
  const spinnerEl = buyNowButton?.querySelector('.loading-spinner');

  if (buyNowForm && buyNowButton && buttonTextEl && spinnerEl) {
    buyNowForm.addEventListener('submit', function (e) {
      e.preventDefault();

      buyNowButton.disabled = true;
      buttonTextEl.style.display = 'none';
      spinnerEl.classList.add('visible');

      const formData = new FormData(buyNowForm);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
      })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch((error) => {
        console.error('Buy Now error:', error);
        buyNowButton.disabled = false;
        buttonTextEl.style.display = 'inline';
        spinnerEl.classList.remove('visible');
      });
    });
  }
});
